export class Axes2Profile {
    constructor(id, nickname, display_name, name, given_name, family_name, email, picture, country, axe, axe_other, home_town, club, bio, public_profile) {
        this._id = id;
        this.nickname = nickname;
        this.display_name = display_name;
        this.name = name;
        this.given_name = given_name;
        this.family_name = family_name;
        this.email = email;
        this.picture = picture;
        this.country = country;
        this.axe = axe;
        this.axe_other = axe_other;
        this.home_town = home_town;
        this.club = club;
        this.bio = bio;
        this.public_profile = public_profile;
    }
}

export class Axes2Tourny {
    constructor(id, title, rounds, players) {
        this.id = id;
        this.title = title;
        this.rounds = rounds;
        this.players = players;
    }
}

export class Axes2Set {
    constructor(id, rounds) {
        this.id = id;
        this.rounds = rounds;
    }
}

export class Axes2Round {
    constructor(id, originalRoundId, type, title, matches) {
        this.id = id;
        this.originalRoundId = originalRoundId;
        this.type = type;
        this.title = title;
        this.matches = matches;
    }
}

export class Axes2Match {
    constructor(id, originalMatchId, matchPlayers) {
        this.id = id;
        this.originalMatchId = originalMatchId;
        this.title = ("Match " + this.id);
        this.matchPlayers = matchPlayers;
        this.display = false;
        this.completed = false;
        this.winnerId = null;
    }
}

export class Axes2MatchPlayer {
    constructor(id, throws, player, bye) {
        this.id = id;
        this.throws = throws;
        this.player = player;
        this.finals = false;
        this.winner = false;
        this.bye = bye;
    }
}

export class Axes2Throw {
    constructor(id, basicScore = 0) {
        this.id = id;
        this.basicScore = basicScore;
        this.xPos = 0;
        this.yPos = 0;
        this.isBullsEye = (basicScore != null && (basicScore == 5 || basicScore == "5")); // Fixed check
        this.isVisible = false;
        this.isActive = false;
        this.scored = false;
        this.axes2Score = (this.basicScore * this.basicScore);
    }
}
